import { FlexRow, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { ChevronUp } from 'baseui/icon';
import { StatefulMenu } from 'baseui/menu';
import { StatefulPopover } from 'baseui/popover';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useStyles } from '../../hooks/useStyles';

export function UserMenu() {
  const { theme, classes } = useStyles();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { logout } = useAuth();

  const onItemSelect = (item: any, close: () => void) => {
    if (item.id === 'logout') {
      logout();
    }
    close();
  };

  return (
    <StatefulPopover
      content={({ close }) => (
        <StatefulMenu
          onItemSelect={({ item }) => onItemSelect(item, close)}
          items={[
            {
              id: 'logout',
              label: (
                <FlexRow
                  classNames={classes.centeredStart}
                  gap={theme.sizing.scale400}
                >
                  <MaterialIcon name="logout" />
                  Salir
                </FlexRow>
              ),
            },
          ]}
        />
      )}
      placement={'bottomRight'}
      triggerType={'click'}
      onOpen={() => setMenuIsOpen(true)}
      onClose={() => setMenuIsOpen(false)}
    >
      <span>
        <StyledButton
          size="compact"
          kind="tertiary"
          endEnhancer={
            <ChevronUp
              title={''}
              overrides={{
                Svg: {
                  style: {
                    transition: 'transform 0.2s ease-in-out',
                    transform: !menuIsOpen ? 'rotate(180deg)' : undefined,
                  },
                },
              }}
            />
          }
          overrides={{
            BaseButton: {
              style: {
                paddingTop: theme.sizing.scale200,
                paddingBottom: theme.sizing.scale200,
              },
            },
          }}
        >
          <FlexRow
            centered
            gap={theme.sizing.scale300}
          >
            <MaterialIcon name="account_circle" />
          </FlexRow>
        </StyledButton>
      </span>
    </StatefulPopover>
  );
}
